export default __webpack_public_path__ + "static/media/t-shirt-icon.f20fc621.png";